<template>
  <v-dialog persistent v-model="openDeleteGreetingModel" max-width="400">
    <v-card>
      <v-card-title class="gc-text-h6">
        {{ lang.actions.delete }}
      </v-card-title>
      <v-card-text v-if="currentGreeting">{{ lang.profile.w3 }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          elevation="0"
          small
          class="primary--text"
          @click="closeLastGreetingsDialog"
        >
          {{ lang.actions.cancel }}
        </v-btn>
        <v-btn
          small
          class="ml-2 btn-bg"
          elevation="0"
          @click="deleteLastGreeting()"
        >
          {{ lang.actions.delete }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteLastGreetingsDialog",
  props: {
    openDeleteGreetingModel: {
      type: Boolean,
      required: true,
    },
    currentGreeting: {
      type: Object
    },
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  methods: {
    deleteLastGreeting() {
      this.$emit("deleteLastGreeting");
    },
    closeLastGreetingsDialog() {
      this.$emit("closeLastGreetingsDialog");
    },
  },
};
</script>

